import styles from "./spinner.module.scss";
import { SPINNER_SIZES, SPINNER_TYPES } from "./spinnerConstants";

const WebSpinner = ({
  size = SPINNER_SIZES.SMALL,
  type = SPINNER_TYPES.PRIMARY,
  isPaused = false,
}) => {
  return (
    <div
      className={`${styles.webSpinnerContainer} ${styles[size]} webSpinnerContainer flex center align-top`}
    >
      <div
        className={`${styles.ldsRing} ${styles[size]} ${styles[type]} ${isPaused ? styles.paused : ""}`}
      >
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  );
};

export default WebSpinner;
